import { openapi } from "../openapi";

export const releaseNotesEnhancer = openapi.enhanceEndpoints({
  endpoints: {
    getMultiplacerReleaseNotesPublished: {
      providesTags: ["ReleaseNotes"],
    },
    getMultiplacerReleaseNotesDeployNotesUnpublished: {
      providesTags: ["ReleaseNotes"],
    },

    getMultiplacerReleaseNotesStatus: {
      providesTags: ["ReleaseNotes"],
    },

    // SAS-url påvirker kun klient-cache av selve SAS-responsen.
    // Ikke nødvendig å invalidere ReleaseNotes her.
    getMultiplacerAssetsSas: {
      providesTags: [],
    },

    postMultiplacerReleaseNotesDeployNotes: {
      invalidatesTags: ["ReleaseNotes"],
    },
    postMultiplacerReleaseNotesPublish: {
      invalidatesTags: ["ReleaseNotes"],
    },

    postMultiplacerReleaseNotesMarkSeen: {
      invalidatesTags: ["ReleaseNotes"],
    },

    // Delete endrer DeployNote (changeItems.media) → oppdater listene
    deleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMedia: {
      invalidatesTags: ["ReleaseNotes"],
    },
  },
});
